import { render, staticRenderFns } from "./activate-account.vue?vue&type=template&id=7ddaaa5c"
import script from "./activate-account.vue?vue&type=script&lang=js"
export * from "./activate-account.vue?vue&type=script&lang=js"
import style0 from "./activate-account.vue?vue&type=style&index=0&id=7ddaaa5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports